import { useForm } from "@mantine/form"
import { httpsCallable } from "firebase/functions"

import { useCloudFunction } from "../../../../hooks/useCloudFunction"
import { firebase } from "../../../../services/firebase/firebase"
import { AwsLambdaUpdateThingData } from "../../../../functions/aws/lambda/aws-lambda-updateThing"
import { Attribute, DeviceDocument } from "../../../../contexts/devices-context"
import { AwsLambdaUpdateGroupData } from "../../../../functions/aws/lambda/aws-lambda-updateGroup"
import { useLanguage } from "../../../../contexts/language-context"

export default (
    attrs: (Record<"duration" | "samplerate" | "gain" | "armed", Attribute>) | undefined,
    organisation: string,
    group: string,
    device?: DeviceDocument,
) => {
    console.log(attrs)
    const { onStart, onSuccess, onError, processing } = useCloudFunction(
        device ? "aws-lambda-updateThing" : "aws-lambda-updateGroup",
    )
    const { L } = useLanguage()
    const form = useForm({
        initialValues: {
            duration: attrs?.duration.value ?? null,
            samplerate: attrs?.samplerate.value?.toString() ?? null,
            gain: attrs?.gain.value ?? null,
            armed: attrs?.armed.value ?? null
        },
    })

    const onSubmit = async (values: typeof form.values) => {
        onStart(L("Updating setting..."))
        const module = {
            name: "audio",
            attributes: [
                ...(form.isDirty("duration") && attrs?.duration.mutable
                    ? [
                          {
                              name: "duration",
                              value: values.duration ?? null,
                          },
                      ]
                    : []),
                ...(form.isDirty("samplerate") && attrs?.samplerate.mutable
                    ? [
                        {
                            name: "samplerate",
                            value: values.samplerate as number ?? null,
                        },
                    ]
                    : []),
                ...(form.isDirty("gain") && attrs?.gain.mutable
                    ? [
                        {
                            name: "gain",
                            value: values.gain as number ?? null,
                        },
                    ]
                    : []),
                ...(form.isDirty("armed") && attrs?.armed.mutable
                    ? [
                        {
                            name: "armed",
                            value: values.armed as boolean ?? null,
                        },
                    ]
                    : [])
            ] as Attribute[],
        }

        try {
            if (device) {
                await httpsCallable<AwsLambdaUpdateThingData>(
                    firebase.functions,
                    "aws-lambda-updateThing",
                )({
                    id: device.id,
                    group,
                    organisation,
                    module,
                })
            } else {
                await httpsCallable<AwsLambdaUpdateGroupData>(
                    firebase.functions,
                    "aws-lambda-updateGroup",
                )({
                    id: group,
                    organisation,
                    module,
                })
            }

            form.resetDirty(values)
            onSuccess()()
        } catch (error) {
            onError()(error)
        }
    }

    return {
        form,
        onSubmit,
        reset: form.reset,
        inheritSettings: () => form.setValues({ samplerate: null, duration: null, gain: null, armed: null }),
        processing,
        attrs,
    }
}
